import _extends from "@babel/runtime/helpers/extends";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/TextLink/TextLinkIcon.js",
  _this = this;
import { testIdProps } from '../../helpers';
import React from 'react';
var TextLinkIcon = function TextLinkIcon(props) {
  var Icon = props.icon;
  return /*#__PURE__*/React.createElement("span", _extends({}, testIdProps(props), {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement(Icon, {
    size: 24,
    color: "currentColor",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 7
    }
  }));
};
export default TextLinkIcon;